import {Credentials, Design, Organization, Project, Snippet, Template, User} from '@mintdata-wsp/common/state/DataState';
import {StorefrontState} from '@mintdata-wsp/common/state/StorefrontState';
import {UIState} from '@mintdata-wsp/common/state/UIState';
import {computed, observable} from 'mobx';
import {RouteComponentProps} from 'react-router';
import {PublishedDesignResponse} from '@mintdata-wsp/common/controllers/network/generated/responses/PublishedDesignResponse';

export class UserSessionState
{
    public currentUser:User = null;
    public currentOrganization:Organization = null;
    public authToken:string = null;

    public static toJSON(userSession:UserSessionState):string
    {
        return JSON.stringify(userSession);
    }

    public static fromJSON(jsonString:string):UserSessionState
    {
        return JSON.parse(jsonString);
    }
}

export class DataState
{
    @observable
    public organizations:Organization[] = [];

    @observable
    public projects:Project[] = [];

    @computed
    public get userDesignCount():number
    {
        if( !this.projects.length )
            return null;

        return this.projects
            .reduce((all:Design[], prj:Project) => all.concat(prj.designs.filter(design => !design.isGuide)), [])
            .length;
    }

    public get guideDesignCount():number
    {
        if( !this.projects.length )
            return null;

        return this.projects
            .reduce((all:Design[], prj:Project) => all.concat(prj.designs.filter(design => design.isGuide)), [])
            .length;
    }

    @observable publishedApps:PublishedDesignResponse[] = null;

    @observable
    public snippets:Snippet[] = null;

    @observable
    public storefront:StorefrontState = new StorefrontState();

    @observable
    public credentials:Credentials[] = [];

    @observable
    public templates:Template[] = [];
}

export class NavigationState
{
    currentRouteProps:RouteComponentProps<any> = null;
    prevUrlLanded:string = '';
    prevUrlLoaded:string = '';
}

export class NetworkState
{
    @observable
    public isSocketReconnecting:boolean = false;

    @observable
    public isFetchingLatestDesign:boolean = false;

    @observable
    public isNetworkTooSlowForMP:boolean = false;

    @observable
    public isDesignSaveInProgress = false;

    @observable
    public isDesignSaveTimedOut = false;

    @observable
    public lastSuccessfulSaveTimestamp = 0;

    public multiplayerInstanceApiEndpoint = null;
}

export class RootState
{
    @observable
    public userSession:UserSessionState = null;
    public readonly navigation:NavigationState = new NavigationState();
    public readonly data:DataState = new DataState();
    public readonly ui:UIState = new UIState();
    public readonly net:NetworkState = new NetworkState();
}

export const rootState = new RootState();
